import React from "react";
import upArrow from "../../../../assets/icons/up-arrow.svg";
import downArrow from "../../../../assets/icons/down-arrow.svg";
import "./style.scss";

const DigInTopFiveRisks = ({ topFiveDigInRisks }) => {
  const digInClassName = "digin-risk";
  return (
    <table>
      {topFiveDigInRisks.map((risk, index) => (
        <thead key={index}>
          <tr key={index} className={`${digInClassName}-details`}>
            <th className={`${digInClassName}-id`}>{index + 1}</th>
            <th className={`${digInClassName}-name`}>{risk.readableName}</th>
            <th className={`${digInClassName}-value`}>{risk.actual_value}</th>
            <th className={`${digInClassName}-shap`} style={{transform: risk.shap > 0 ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              <img src={risk.shap > 0 ? upArrow : downArrow} alt="vector" />
            </th>
          </tr>
        </thead>
      ))}
    </table>
  );
};

export default DigInTopFiveRisks;
